import React from 'react';

// TODO: LOGO 
const CustomerLogo = () => {
  return (
    <div>
      
    </div>
  );
};

export default CustomerLogo;


// WEBPACK FOOTER //
// ./src/components/logo/CustomerLogo.js